/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampProgramPaginateResponse } from '../../models/camp-program-paginate-response';

export interface GetCampProgramIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'type' | 'name' | 'label' | 'price' | 'description' | 'descriptionShort' | 'descriptionTitle' | 'descriptionMeta' | 'descriptionLink';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'type' | 'name' | 'label' | 'price' | 'description' | 'descriptionShort' | 'descriptionTitle' | 'descriptionMeta' | 'descriptionLink';

/**
 * Filter program id or list of program ids comma separated
 */
  id?: string;

/**
 * Filter by type
 */
  type?: 'standard' | 'zusatz';

/**
 * Filter by name
 */
  name?: string;

/**
 * Filter by camp id
 */
  camp?: number;

/**
 * Filter by trip id
 */
  trip?: number;

/**
 * Filter by program label
 */
  label?: string;
}

export function getCampProgramIndex(http: HttpClient, rootUrl: string, params?: GetCampProgramIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<CampProgramPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getCampProgramIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('type', params.type, {});
    rb.query('name', params.name, {});
    rb.query('camp', params.camp, {});
    rb.query('trip', params.trip, {});
    rb.query('label', params.label, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampProgramPaginateResponse>;
    })
  );
}

getCampProgramIndex.PATH = '/v1/camp-program';
